import React from "react";
import './App.css';
import FacilityTable from './components/FacilityTable';
import BeaconTable from './components/BeaconTable';
import SubmersionTable from './components/SubmersionTable';
import WarningTable from './components/WarningTable';
import HubTable from './components/HubTable';
import HubPopup from "./components/HubPopup";
import ThirdPartyWebHookTable from "./components/ThirdPartyWebHookTable"
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import SQLEditor from './components/SQLEditor';
import SystemSettingsEditor from './components/SystemSettingsEditor';
import GoogleSecurity from "./components/GoogleSecurity"
import OrganizationTable from "./components/OrganizationTable"
import DeviceTable from "./components/DeviceTable"
import HubspotDealTable from "./components/HubspotDealTable"
import OrderHeaderTable from "./components/OrderHeaderTable"
import OrderAllTable from "./components/OrderAllTable.js";
import db from "./components/db";
import queryString from 'query-string';
var functions = require("./components/functions.js");

/*
    WAVE Device App
    This app keeps track of Waves products that are produced and Customers

    notes:
    you can start server with a hostname
        http://localhost:3000/?hostname=w10153c14
    you can start server with a major
        http://localhost:3000/?major=8008
    you can start server with a facility
        http://localhost:3000/?facilityId=11
    you can start server with a facility
        http://localhost:3000/?companyId=21444971418
    you can start server with a organization
        http://localhost:3000/?organizationId=5       
    you can start server with a deal
        http://localhost:3000/?dealId=51714372747        
*/

class App extends React.Component {
   

     // Constructor 
    constructor(props) {
        super(props);
        let stateObject = {
            clientVersion:'0.0.6.0',
            serverVersion:'unk',
            tabIndex:0,
            showTabs:false,
            securityObject:{connected:false}
        };

        // add objects to this from other components
        SystemSettingsEditor.init(stateObject);

        // initalize this with stateObject
        this.state=stateObject;
    }

    // render
    render() {
        let title=process.env.REACT_APP_TITLE;
        if(!title || title===""){
            title = "title not found check /client/.env";
        }
        if(!this.state.showTabs){
            return (
                <div>
                    <h1>{title}</h1>
                    ver:{this.state.clientVersion}  
                    <br />
                    <span className="mobileHide">Desktop</span>
                    <span className="mobileShow">Mobile</span> 
                    <br />Screen Width:{window.screen.width} Height:{window.screen.height}
                    <br />Window Width:{window.innerWidth} Height:{window.innerHeight}
                    
                    <div>
                        <GoogleSecurity 
                            onChangeConnection={this.changeConnection.bind(this)}
                        > </GoogleSecurity>
                    </div>
                    <div>
                        <ul>
                            <li>
                                <a href="https://sites.google.com/wavedds.com/internal/home" rel="noopener noreferrer" target="_blank">WAVE Quick Look</a>
                            </li>
                            <li>
                                <a href="https://dashboard.wavedds.net/login" rel="noopener noreferrer" target="_blank">Grafana</a>
                            </li>
                            <li>
                                <a href="https://katanamrp.com/login/" rel="noopener noreferrer" target="_blank" >Katana Login</a>
                            </li>
                            <li>
                                <a href="https://factory.katanamrp.com/sales" rel="noopener noreferrer" target="_blank">Katana Sales</a>
                            </li>
                            <li>
                                <button onClick={() => functions.openWindow( functions.gatewayUrl() ) } >AWS Bastion Host Gateway</button>
                            </li>                                                                             
                        </ul>
                    </div>          
                </div>
            )
        }
        return (
            <div className = "App">
                <h1>{process.env.REACT_APP_TITLE}</h1>
                <div >

                    {/*
                        profile Menu
                    */}             
                    <div className="profile" hidden={!this.state.securityObject.connected}>                
                        <button onClick={() => this.openAbout() }>About</button>
                        <button onClick={() => functions.openWindow( functions.gatewayUrl() ) }>AWS Bastion Host Gateway</button>
                        <img src={this.state.userPicture} alt={this.state.userName} height="20px"></img>
                        {this.state.userName}
                        <button onClick={this.handleLogout}>x</button>
                    </div>
                    {/*
                        Main Screen
                    */}            
                    <Tabs selectedIndex={this.state.tabIndex} 
                            onSelect={
                                tabIndex => this.setState({ 
                                    tabIndex : tabIndex,
                                    initOrganizationId:undefined,
                                    initMajor:undefined,
                                    initFacilityId:undefined,
                                    initCompanyId:undefined,
                                    initHostname:undefined,
                                    initDealId:undefined
                                })
                                
                            }>
                            <TabList>
                                <Tab className={this.state.securityObject.connected ? "hidden":""} >Please Wait...</Tab>
                                <Tab>HubSpot Company/Facility</Tab>
                                <Tab>Hubs</Tab>
                                <Tab>Devices</Tab>
                                <Tab>Beacons</Tab>
                                <Tab>Submersions</Tab>
                                <Tab>Warnings</Tab>
                                <Tab>Order Fulfillment</Tab>
                                <Tab>Third Party Web Hooks</Tab>
                                <Tab>SQL</Tab>
                                <Tab>Settings</Tab>
                                <Tab>Organization</Tab>
                            </TabList>                    
                            <TabPanel className={this.state.securityObject.connected ? "hidden":""} >
                                Please Wait...
                            </TabPanel>
                            <TabPanel>
                                <FacilityTable 
                                    securityObject={this.state.securityObject}
                                    initFacilityId={this.state.initFacilityId}
                                    initCompanyId={this.state.initCompanyId}
                                ></FacilityTable>                                
                            </TabPanel>
                            <TabPanel>
                                <HubTable 
                                    securityObject={this.state.securityObject}
                                    initHostName={this.state.initHostName}
                                ></HubTable>
                            </TabPanel>  
                            <TabPanel>
                                <Tabs>
                                    <TabList>
                                        <Tab>All Devices</Tab>
                                        <Tab>Devices In Inventory</Tab>
                                        <Tab>Boards In Inventory</Tab>
                                    </TabList>
                                    <TabPanel>
                                        <DeviceTable 
                                            securityObject={this.state.securityObject}
                                        ></DeviceTable>                                
                                    </TabPanel>
                                    <TabPanel>
                                        <DeviceTable 
                                            securityObject={this.state.securityObject}
                                            facilityId={1}
                                            facilityName="Wave Inventory"
                                        ></DeviceTable>                                
                                    </TabPanel>
                                    <TabPanel>
                                        <DeviceTable 
                                            securityObject={this.state.securityObject}
                                            facilityId={12}
                                            facilityName="Board Inventory"
                                        ></DeviceTable>                                
                                    </TabPanel>
                                </Tabs>
                            </TabPanel>
                            <TabPanel>
                                <BeaconTable 
                                    securityObject={this.state.securityObject}
                                    initMajor={this.state.initMajor}
                                ></BeaconTable>
                            </TabPanel>  
                            <TabPanel>
                                <SubmersionTable 
                                    securityObject={this.state.securityObject}
                                ></SubmersionTable>
                            </TabPanel>                                                   
                            <TabPanel>
                                <WarningTable 
                                    securityObject={this.state.securityObject}
                                ></WarningTable>
                            </TabPanel>    
                            <TabPanel>
                                <Tabs>
                                    <TabList>
                                        <Tab>HubSpot Deals</Tab>
                                        <Tab>Stand Alone Order</Tab>
                                        <Tab>Returns</Tab>
                                        <Tab>Order Search</Tab>
                                    </TabList>
                                    <TabPanel>
                                        <HubspotDealTable 
                                            securityObject={this.state.securityObject}
                                            initDealId={this.state.initDealId}
                                        ></HubspotDealTable>
                                    </TabPanel>
                                    <TabPanel>
                                        <OrderHeaderTable
                                            securityObject={this.state.securityObject}
                                            title="Stand Alone Order"
                                            orderType="SA"
                                            orderPurposeList={ this.state.securityObject.systemSettings.order_purpose_stand_alone }
                                            >
                                        </OrderHeaderTable>
                                    </TabPanel>  
                                    <TabPanel>
                                        <OrderHeaderTable
                                            securityObject={this.state.securityObject}
                                            title="Returns"
                                            orderType="RET"
                                            orderPurposeList={ this.state.securityObject.systemSettings.order_purpose_return }
                                            >
                                        </OrderHeaderTable>
                                    </TabPanel>
                                    <TabPanel>
                                        <OrderAllTable
                                            securityObject={this.state.securityObject}
                                            >
                                        </OrderAllTable>
                                    </TabPanel>                                                                      
                                </Tabs>
                            </TabPanel>                                
                            <TabPanel>
                                <ThirdPartyWebHookTable 
                                    securityObject={this.state.securityObject}
                                ></ThirdPartyWebHookTable>
                            </TabPanel>                                                                                         
                            <TabPanel>
                                <SQLEditor 
                                    securityObject={this.state.securityObject}
                                ></SQLEditor>
                            </TabPanel>                      
                            <TabPanel>
                                <SystemSettingsEditor
                                        securityObject={this.state.securityObject}
                                ></SystemSettingsEditor>
                            </TabPanel>
                            <TabPanel>
                                <OrganizationTable 
                                    securityObject={this.state.securityObject}
                                    initOrganizationId={this.state.initOrganizationId}
                                ></OrganizationTable>                                
                            </TabPanel>
                        </Tabs>
                </div>

            </div>
        );
    }

    // set new connection object in this
    changeConnection(newConnectionObject){
        this.setState({
            securityObject: newConnectionObject
        })
        this.createHubIfNotExists();
        this.showBeaconTab();
    }
    showBeaconTab(){
        const params = queryString.parse(window.location.search);
        if(params.major){
            this.setState({
                tabIndex:4
            });
        } else if(params.facilityId){
                this.setState({
                    tabIndex:1
                });
        } else if(params.companyId){
            this.setState({
                tabIndex:1
            });                
        } else if(params.organizationId){
            this.setState({
                tabIndex:11
            });                
        } else if(params.dealId){
            this.setState({
                tabIndex:7
            });                
        } else if(this.state.securityObject.connected){
            this.setState({
                tabIndex:1
            });            
        }
    }
    createHubIfNotExists(){
        const params = queryString.parse(window.location.search);
        if(params.major){
            this.showTabs(undefined,params.major);
        } else if(params.organizationId){
            this.showTabs(undefined,undefined, params.organizationId);            
        } else if(params.facilityId){
            this.showTabs(undefined,undefined,undefined,params.facilityId);  
        } else if(params.companyId){
            this.showTabs(undefined,undefined,undefined,undefined,params.companyId);  
        } else if(params.dealId){
            this.showTabs(undefined,undefined,undefined,undefined,undefined,params.dealId);  
        } else if(params.hostname){
            db.getHubs( 
                ""
                ,""
                ,params.hostname
                ,""
                ,this.state.securityObject
                ,(hubList) => { 
                    if(hubList.length===0){
                        if(window.confirm(`${params.hostname} does not exist would you like to create it?`)){
                            let hub=Object.assign({}, HubPopup.emptyHub);
                            hub.hostname=params.hostname;
                            db.saveData( this.state.securityObject
                                , hub
                                ,"api/updateHub"
                                , this.showTabs(params.hostname)
                                );
                        } else {
                            this.showTabs(undefined);    
                        }
                    } else {
                        this.showTabs(params.hostname);
                    }
                }
            )            
        } else {
            this.showTabs(undefined);
        }
    }
    showTabs(hostname, major, organizationId, facilityId, companyId,dealId){
        let newStates={showTabs:true};
        if(major){
            newStates.initMajor=major;
            newStates.tabIndex=4;
        } else if(hostname){
            newStates.initHostName=hostname;
            newStates.tabIndex=2;
        } else if(organizationId){
            newStates.initOrganizationId=organizationId;
            newStates.tabIndex=11;
        } else if(facilityId){
            newStates.initFacilityId=facilityId;
            newStates.tabIndex=1;
        } else if(companyId){
            newStates.initCompanyId=companyId;
            newStates.tabIndex=1;
        } else if(dealId){
            newStates.initDealId=dealId;
            newStates.tabIndex=7;
        }
        this.setState(newStates);
    }
    openAbout(){
        db.getServerVersion( this.state.securityObject,
            (result)=>{
                this.setState({serverVersion:result})
                window.alert( //{process.env.REACT_APP_TITLE} +"\n"+
                    `Server Version:${this.state.serverVersion} \n `+
                    `Client Version:${this.state.clientVersion} ` )

            });
    }
}
   
export default App;
